import * as actionTypes from './actionTypes';

const initialState = {
  settings: {},
  error: { bidError: false, message: '' },
  isSettingsFetching: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SETTINGS_REQUEST:
      return { ...state, settings: {}, error: {}, isSettingsFetching: true };
    case actionTypes.FETCH_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: action.settings,
        error: {},
        isSettingsFetching: false
      };
    case actionTypes.FETCH_SETTINGS_FAILURE:
      return { ...state, isSettingsFetching: false };
    case actionTypes.UPDATE_BIDMODE_SUCCESS:
      return {
        ...state,
        settings: action.settings,
        error: {},
        isSettingsFetching: false
      };
    case actionTypes.UPDATE_BIDMODE_FAILURE:
      return { ...state, isSettingsFetching: false };
    default:
      return state;
  }
};

export { reducer as default };
